import React from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";
import { getCurrencyValue } from "../../../services/restaurant";
import { fixedNumber } from "../../../utils/math-util.js";

const HistoryFooter = ({ t, items }) => {

  const totals = items && items.length
    ? items.reduce(
      (acc, item) => {
        acc.totalAppOpensCount += item.total_app_opens || 0;
        acc.totalOrdersCount += item.total_orders || 0;
        acc.totalPrice += item.total_price || 0;
        acc.totalDiscount += item.total_discount || 0;
        acc.beautifyPriceCount += (item.total_price || 0) - (item.total_discount || 0);
        if (item?.total_price && item?.total_orders) {
          acc.averageRevenue += Number((item.total_price / item.total_orders).toFixed(0));
          acc.countOfAverageRevenue += 1;
        }
        return acc;
      },
      {
        totalAppOpensCount: 0,
        totalOrdersCount: 0,
        totalPrice: 0,
        totalDiscount: 0,
        beautifyPriceCount: 0,
        averageRevenue: 0,
        countOfAverageRevenue: 0,
      }
    )
    : {
      totalAppOpensCount: 0,
      totalOrdersCount: 0,
      totalPrice: 0,
      totalDiscount: 0,
      beautifyPriceCount: 0,
      averageRevenue: 0,
      countOfAverageRevenue: 0,
    };


  return (<div className={classNames("history-footer")}>
    {items &&
      !!items.length && (
        <>
          <div className={classNames("history-footer-block title")}>
            <div className={classNames('total-time')}>{t('admin-orders.ORDER_SUMMARY_TOTAL_LABEL')}</div>
          </div>
          <div className={classNames("history-footer-block totalAppOpensCount")}>
            <div className={classNames('total-time')}>{totals.totalAppOpensCount}</div>
          </div>
          <div className={classNames("history-footer-block totalOrdersCount")}>
            <div className={classNames('total-time')}>{totals.totalOrdersCount}</div>
          </div>
          <div className={classNames("history-footer-block totalPrice")}>
            <div className={classNames('total-time')}>{fixedNumber(totals.totalPrice, 2)} {getCurrencyValue()}</div>
          </div>
          <div className={classNames("history-footer-block totalDiscount")}>
            <div className={classNames('total-time')}>{fixedNumber(totals.totalDiscount, 2)} {getCurrencyValue()}</div>
          </div>
          <div className={classNames("history-footer-block beautifyPriceCount")}>
            <div className={classNames('total-time')}>{fixedNumber(totals.beautifyPriceCount, 2)} {getCurrencyValue()}</div>
          </div>
          <div className={classNames("history-footer-block last-total")}>
            <div className={classNames('total-time')}>{totals.averageRevenue && totals.countOfAverageRevenue ? fixedNumber(totals.averageRevenue / totals.countOfAverageRevenue, 2) : 0} {getCurrencyValue()}</div>
          </div>
        </>
      )}
  </div>);
};

export default withTranslation()(HistoryFooter);
